// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3YDP7","approved":"Status_approved__1S2KC","rejected":"Status_rejected__nZxrn","expired":"Status_expired__3v7aV","label":"Status_label__fIAuy"};